<div class="modal inmodal fade in view-attachment-modal" [ngClass]="{'show': showModal}">
    <div class="modal-dialog ">
        <div class="modal-content">

            <h3>{{data.name}}</h3>

            <button type="button" class="close" (click)="hideModal()">
                <span>×</span><span class="sr-only">Close</span>
            </button>
            <div class="image-and-controls-container">
                <div class="previous">
                    <div><</div>
                </div>
                <div class="image">
                    <img [src]="data.path">
                </div>
                <div class="next">
                    <div>></div>
                </div>
            </div>
            <div class="select-image" (click)="setImage()">
                <i class="fa fa-check-circle" aria-hidden="true"></i>
                Select
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/notices/zoom-image-modal/zoom-image-modal.component.html